var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.newsNum
    ? _c("div", { staticClass: "new-comments" }, [
        _c(
          "div",
          {
            staticClass: "new-comments-container",
            on: { click: _vm.showCommentsDetail },
          },
          [
            _c("svg-icon", {
              staticClass: "mx-10",
              attrs: { "icon-name": "icon-notice", size: 20 },
            }),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("newComments.title", {
                    num: _vm.newsNum,
                    role: _vm.isKpmgUser
                      ? _vm.$t("newComments.client")
                      : _vm.$t("newComments.kpmg"),
                  })
                )
              ),
            ]),
          ],
          1
        ),
        _vm.commentsDetailVisible
          ? _c(
              "div",
              [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: "",
                      width: "55%",
                      title: _vm.$t("newComments.dlgTitle", {
                        role: _vm.isKpmgUser
                          ? _vm.$t("newComments.client")
                          : _vm.$t("newComments.kpmg"),
                      }),
                      footer: null,
                    },
                    on: { close: _vm.onCancel },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "comments-all" },
                      _vm._l(_vm.newCommentList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.type,
                            staticClass: "border-normal comment-row mb-15",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "left flex item-center" },
                              [
                                _c("el-avatar", {
                                  staticClass: "mr-20 flex-0",
                                  attrs: { size: "medium", src: _vm.circleUrl },
                                }),
                                _c("div", [
                                  _c("div", { staticClass: "messageBy" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.commentUser) +
                                        "\n                " +
                                        _vm._s(item.sendUserName) +
                                        "\n                "
                                    ),
                                    item.commentTime
                                      ? _c(
                                          "span",
                                          { staticClass: "create-date" },
                                          [
                                            _vm._v(
                                              "【" +
                                                _vm._s(
                                                  _vm._f("formatDateTime")(
                                                    item.commentTime
                                                  )
                                                ) +
                                                "】"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    item.createDate
                                      ? _c(
                                          "span",
                                          { staticClass: "create-date" },
                                          [
                                            _vm._v(
                                              "【" +
                                                _vm._s(
                                                  _vm._f("formatDateTime")(
                                                    item.createDate
                                                  )
                                                ) +
                                                "】"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c("div", { staticClass: "comment mt-10" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.comment) +
                                        "\n                " +
                                        _vm._s(item.messageContent) +
                                        "\n              "
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "right" },
                              [
                                _vm.messageType === "1" ||
                                _vm.messageType === "2"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("serialNo")) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.serialNo)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_entityList")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.entityName)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_topicName")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.topicName)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "5"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_EntityList")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.entityName)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_Category")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.renderCategory(item.category)
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "3"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_EntityList2")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.entityName)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_Category")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.category)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "4"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_Category")
                                            ) + ":"
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(item.category)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "6"
                                  ? [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("admin.invoiceNumber")
                                            ) +
                                            ":\n              "
                                        ),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.invoiceNumber) +
                                            "\n              "
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "7"
                                  ? [
                                      _c("div", { staticClass: "label" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("admin.entityId")) +
                                            "\n              "
                                        ),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.entityId) +
                                            "\n              "
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "9" ||
                                _vm.messageType === "8"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_entityList")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getEntityName(item))
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_matter")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.matter)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "11"
                                  ? [
                                      _c("div", [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "confirmation.details_list.table.unique_id_nocss"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.uniqueId)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "confirmation.details_list.table.entity_name"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(item.confirmationEntityName)
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "confirmation.details_list.table.addressee_entity_name"
                                              )
                                            ) + ":"
                                          ),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.addrEntityName)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm.messageType === "12"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "font-bolder" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("TABLE_HEADER_ENTITIES")
                                              ) +
                                              ":\n              "
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "mt-10" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(item.entityName)),
                                        ]),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }